const initCounter = () => {
  const sand_counter_box = document.getElementById('counter-box');
  if(sand_counter_box){
    const sand_counter_elements = document.querySelectorAll('.count') // get the element
    const doTheCountingMagic = (el) => {
      const duration = 2000 // duration in ms
      let start // set on the first step to the timestamp provided
      let final = parseInt(el.dataset.count, 10) // parse out the final number
      const step = ts => {
        if (!start) {
          start = ts
        }
        let progress = (ts - start) / duration
        if (progress > 1) progress = 1;
        el.querySelector('.sand-count-number').textContent = Math.floor(progress * final).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        if (progress < 1) requestAnimationFrame(step)
      }
      requestAnimationFrame(step)
    }
    let counted = false;

    /*function isInViewPort(element) {
      let bounding = element.getBoundingClientRect();
      if (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
      ) {
        return true;
      } else {
        return false;
      }
    }
   */
    function isInViewPort(element) {
      let bounding = element.getBoundingClientRect();
      if (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      ) {
        return true;
      } else {
        return false;
      }
    }

    window.addEventListener('scroll', function (event) {
      if (isInViewPort(sand_counter_box) && !counted) {
        sand_counter_elements.forEach(doTheCountingMagic);
        counted = !counted;
      }
    }, false);
  }
};
export default initCounter;
